import React from 'react';

// Packages
import { Button, Container, OverlayTrigger, Spinner, Table, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FieldsTable = (props) => {
	const { tableLoading, tableData, updateField, deleteField } = props;

	return (
		<div>
			<Table responsive>
				<thead style={{backgroundColor: '#e7f1ff'}}>
					<tr>
						<th>Label</th>
						<th>Value</th>
						<th>Description</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					{tableLoading 
						?	<tr>
								<td className='text-center' colSpan={9}>
									<Container className='d-flex align-items-center justify-content-center' style={{ height: '5rem' }}>
										<Spinner animation='border' style={{ width: '2.5rem', height: '2.5rem', color: '#004982' }} />
									</Container>
								</td>
							</tr>
						:	tableData.length > 0
							?	tableData.map((field) => (
									<tr key={field?._id?.$oid}>
										<td>{field?.label}</td>
										<td>{field?.name}</td>
										<td>{field?.description}</td>
										<td>
											<OverlayTrigger
												placement='top'
												overlay={<Tooltip id='button-tooltip-2'>Edit</Tooltip>}
											>
												<Button
													type='button'
													className='jobs-actions me-3'
													onClick={() => updateField(field)}
												>
													<i className='bi bi-pencil-fill fs-5'></i>
												</Button>
											</OverlayTrigger>
											<OverlayTrigger
												placement='top'
												overlay={<Tooltip id='button-tooltip-2'>Remove</Tooltip>}
											>
												<Button
													type='button'
													className='jobs-actions'
													onClick={() => deleteField(field?._id?.$oid)}
												>
													<i className='bi bi-trash-fill fs-5'></i>
												</Button>
											</OverlayTrigger>
										</td>
									</tr>
								))
							:	<tr>
									<td className='text-center' colSpan={9}>No fields found</td>
								</tr>
					}
				</tbody>
			</Table>
		</div>
	)
}

FieldsTable.propTypes = {
	tableLoading: PropTypes.bool.isRequired,
	tableData: PropTypes.array.isRequired
}

export default FieldsTable;
